import {
    AddUpdateRemoveCompanySelectionDescriptions,
    CompanySelectionDescriptionActionTypes,
    LoadCompanySelectionDescriptionByCompanyId,
    ReloadCompanySelectionDescriptionByIds
} from '../actions/company-selection-description.actions';
import { Injectable } from '@angular/core';
import { CompanySelectionDescriptionControllerService } from '@iota/iota-management-portal-v4-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concat, forkJoin, map, mergeMap, of, switchMap, take } from 'rxjs';

@Injectable()
export class CompanySelectionDescriptionEffects {
    loadCompanySelectionDescriptionsByCompanyId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadCompanySelectionDescriptionByCompanyId),
            mergeMap(({ companyId }) =>
                this.apiService.getAllCompanySelectionDescriptionsByCompany(companyId).pipe(
                    take(1),
                    switchMap((selectionDescription) => [
                        {
                            type: CompanySelectionDescriptionActionTypes.LoadCompanySelectionDescriptionSuccess,
                            companySelectionDescriptions: selectionDescription ?? [],
                            companyId
                        }
                    ]),
                    catchError((error) =>
                        of({ type: CompanySelectionDescriptionActionTypes.LoadCompanySelectionDescriptionFailure, error })
                    )
                )
            )
        )
    );

    reloadCompanySelectionDescriptionsByIds$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReloadCompanySelectionDescriptionByIds),
            mergeMap(({ companySelectionDescriptionIds }) =>
                this.apiService.getAllCompanySelectionDescriptionsByIds(companySelectionDescriptionIds).pipe(
                    take(1),
                    switchMap((selectionDescriptions) => [
                        {
                            type: CompanySelectionDescriptionActionTypes.ReloadCompanySelectionDescriptionByIdsSuccess,
                            selectionDescriptions
                        }
                    ]),
                    catchError((error) =>
                        of({ type: CompanySelectionDescriptionActionTypes.ReloadCompanySelectionDescriptionByIdsFailure, error })
                    )
                )
            )
        )
    );

    addUpdateRemoveCompanySelectionDescriptions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AddUpdateRemoveCompanySelectionDescriptions),
            mergeMap((addUpdateInformation) =>
                concat(
                    forkJoin([
                        ...(addUpdateInformation.upsertedCompanySelectionDescriptions?.updatedCompanySelectionDescriptions.map((added) =>
                            this.apiService.upsertCompanySelectionDescription(added)
                        ) ?? []),
                        this.apiService.deleteCompanySelectionDescriptionsByIds(
                            addUpdateInformation.upsertedCompanySelectionDescriptions.removedCompanySelectionDescriptionIds
                        )
                    ])
                ).pipe(
                    take(1),
                    map(() => {
                        return {
                            type: CompanySelectionDescriptionActionTypes.LoadCompanySelectionDescriptionByCompanyId,
                            companyId: addUpdateInformation.companyId
                        };
                    }),
                    catchError((error) =>
                        of({
                            type: CompanySelectionDescriptionActionTypes.AddUpdateRemoveCompanySelectionDescriptionsFailure,
                            error
                        })
                    )
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private apiService: CompanySelectionDescriptionControllerService
    ) {}
}
